import { action } from 'satcheljs';

export const startCheckPerm = action('startCheckPerm', (composeId: string) => ({
    composeId: composeId,
}));

export const finishCheckPerm = action('finishCheckPerm', (composeId: string) => ({
    composeId: composeId,
}));

export const addCheckPerm = action('addCheckPerm', (composeId: string) => ({
    composeId: composeId,
}));

export const removeCheckPerm = action('removeCheckPerm', (composeId: string) => ({
    composeId: composeId,
}));

export const updateCheckPermCount = action(
    'updateCheckPermCount ',
    (composeId: string, offset: number) => ({
        composeId: composeId,
        offset: offset,
    })
);
